import React from "react";
import {Box, Divider, Link, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import {useI18N, useLocation} from "../../../common/common";
import {CustomButton, ResponsiveDialog} from "@hapinest/theme";
import { MEMBERSHIP, RESERVATIONS_WAITING_LIST } from "../../../common/routes";
import { WAITING_LIST_ENTRIES_MAX } from "../../../common/constant";


const ApartmentWaitingListDialog = ({isOpen, onClose, resortName, expirationDaysBeforeArrival, cannotEnterReason}) => {
    const {i18n} = useI18N();
    const {navigate} = useLocation();

    const waitingListHyperlink = (str) => {
        return (
            <Link
                key={str}
                href={RESERVATIONS_WAITING_LIST}
            >
                <Typography
                    variant={"body2"}
                >
                    {str}
                </Typography>
            </Link>
        );
    };

    const waitingListCannotEnterMessageType = {
        "waiting_list_full": i18n("view.apartment_card.alternatives.waiting_list_description_waiting_list_full"),
        "user_already_joined": i18n("view.apartment_card.alternatives.waiting_list_description_user_already_joined"),
        "user_waiting_list_limit": i18n("view.apartment_card.alternatives.waiting_list_description_user_waiting_list_limit", {numOfWaitingLists: WAITING_LIST_ENTRIES_MAX, hyperlink: waitingListHyperlink, resortName: resortName}),
        "today_too_close_to_arrival_date": i18n("view.apartment_card.alternatives.waiting_list_description_days_from_arrival", {expirationDaysBeforeArrival}),
        "trial_user": i18n("view.apartment_card.alternatives.waiting_list.not_available_for_trials"),
    };

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={onClose}
            disableBackdropClick
            hasCloseButton
            maxWidth="xs"
            content={
                <>
                    {!cannotEnterReason ? (
                        <>
                            <img
                                src="/images/booking-loading-calendar-pictogram.svg"
                                alt="calendar icon"
                                style={{display: "block", margin: "0 auto"}}
                            />

                            <Box
                                mt={1}
                            >
                                <Typography
                                    variant="h3"
                                    align="center"
                                >
                                    {i18n("view.apartment_card.waiting_list_success_title", {resortName})}
                                </Typography>
                            </Box>

                            <Box
                                mt={1.5}
                                mb={3}
                            >
                                <Typography
                                    variant="body2"
                                    align="center"
                                >
                                    {i18n("view.apartment_card_waiting_list_success_description_before_arrival_days", {expirationDaysBeforeArrival})}
                                </Typography>
                            </Box>

                            <Divider />

                            <Box
                                mt={3}
                                mb={4}
                            >
                                <CustomButton
                                    color="black"
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => navigate(RESERVATIONS_WAITING_LIST)}
                                >
                                    <Typography variant="subtitle2">
                                        {i18n("view.apartment_card_waiting_list_cta")}
                                    </Typography>
                                </CustomButton>
                            </Box>
                        </>
                    ) : (
                        <>
                            <img
                                src={"/images/waiting-list-notifications.svg"}
                                alt="calendar icon"
                                style={{display: "block", margin: "0 auto"}}
                            />

                            <Box
                                mt={5}
                            >
                                <Typography
                                    variant="h3"
                                    align="center"
                                    gutterBottom
                                >
                                    {i18n("view.apartment_card.waiting_list_joining_not_possible")}
                                </Typography>

                                <Typography
                                    align="center"
                                >
                                    {waitingListCannotEnterMessageType[cannotEnterReason]}
                                </Typography>
                            </Box>

                            <Box
                                mt={5}
                                mb={3}
                                mx="auto"
                                textAlign="center"
                            >
                                {cannotEnterReason !== "trial_user" ? (
                                    <CustomButton
                                        variant="contained"
                                        disableElevation
                                        onClick={onClose}
                                    >
                                        {i18n("common.label.ok")}
                                    </CustomButton>
                                ) : (
                                    <CustomButton
                                        variant="contained"
                                        disableElevation
                                        onClick={() => navigate(MEMBERSHIP)}
                                    >
                                        {i18n("common.label.learn_more")}
                                    </CustomButton>
                                )}
                            </Box>
                        </>
                    )}
                </>
            }
        />
    );
};

ApartmentWaitingListDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    resortName: PropTypes.string,
    expirationDaysBeforeArrival: PropTypes.number,
    cannotEnterReason: PropTypes.string,
};

export default ApartmentWaitingListDialog;
